exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prev-policy[data-v-8f4fa6b6]{padding:55px 10px 0!important}.prev-policy-label[data-v-8f4fa6b6]{display:inline-block;font-size:14px;margin-top:4px;color:red}.prev-policy-wait[data-v-8f4fa6b6]{display:inline-block;font-size:14px;margin-top:4px;color:#00ba57}.prev-policy-label p[data-v-8f4fa6b6]{margin-bottom:0}.prev-policy-label a[data-v-8f4fa6b6]{font-size:14px}.percent-input[data-v-8f4fa6b6]{position:relative}.percent-symbol[data-v-8f4fa6b6]{position:absolute;top:50%;right:8px;-webkit-transform:translateY(-50%);transform:translateY(-50%);font-size:16px}.tip-icon[data-v-8f4fa6b6]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8f4fa6b6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/mortgage/MortgageCalcInfo.vue
// module id = TGT2
// module chunks = 0